import React from 'react';
import { LoginNotiOneStyle, LoginNotiTwoStyle, loginUserBg, logown, LoginNotiThirdStyle, LoginNotiFourStyle } from '../../img';
import './SignIn.scss';

const CommonCard = ({
  type
}) => {
  return (
    <div className="nf_login-left nf_login-box" >
      <div className="login-side-text">
        <h2 className="signup-noti-text">
          When people hear about your brand from real people, they trust your brand and also establishes your brand as a prominent one.
        </h2>
      </div>
      <div className="login-display-noti">
        <img className="notifiavtion-one" src={LoginNotiOneStyle} alt="" id={`${type + '-1'}`} style={{ display: 'none' }} />
        <img src={LoginNotiTwoStyle} alt="" id={`${type + '-2'}`} style={{ display: 'none' }} />
        <img src={LoginNotiThirdStyle} alt="" id={`${type + '-3'}`} style={{ display: 'none' }} />
        <img src={LoginNotiFourStyle} alt="" id={`${type + '-4'}`} style={{ display: 'none' }} />
      </div>
      <div className="loginusercomputer">
        <img src={loginUserBg} alt="" />
      </div>

      <a href='https://wisernotify.com/' className="login-logo">
        <img src={logown} alt="" />
      </a>
    </div>
  );
};

export default CommonCard;


// WEBPACK FOOTER //
// ./src/components/SignIn/CommonCard.js